import $ from 'jquery'
import swipeToVerify from './swipeToVerify'

export default function initApplyModal() {
    const applyModal = $('.apply_modal')
    const name_node = $('#applyName')
    const phone_node = $('#applyPhone')
    const area_node = $('#area')

    $('.apply_btn').on('click', function () {
        applyModal.fadeIn()
    })
    $('.apply_modal_close_btn').on('click', function () {
        applyModal.fadeOut()
        resetFormVal()
    })

    function setErrorStyle(curNode, text) {
        const dis_n = curNode.parent().find(".dis_n");
        if (text) {
            dis_n.text(text)
        }
        dis_n.fadeIn();
    }

    function setSuccessStyle(curNode) {
        curNode.parent().find('.dis_n').fadeOut()
    }

    function resetFormVal() {
        name_node.val('')
        phone_node.val('')
        area_node.val('')
    }

    function xss(value) {
        const codeSpan = /(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm
        const codeBlock =
            /(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=~0))/g
        const spans = []
        const blocks = []
        let text = String(value).replace(/\r\n/g, '\n').replace('/\r/g', '\n')
        // text = '\n\n' + text + '\n\n';
        text = text.replace(codeSpan, function (code) {
            spans.push(code)
            return '`span`'
        })
        text += '~0'
        text = text
            .replace(codeBlock, function (whole, code, nextChar) {
                blocks.push(code)
                return '\n\tblock' + nextChar
            })
            .replace(/&(?!\w+;)/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/“/g, '&quot;')
            .replace(/`span`/g, function () {
                return spans.shift()
            })
            .replace(/\n\tblock/g, function () {
                return blocks.shift()
            })
            .replace(/~0$/, '')
            .replace(/^\n\n/, '')
            .replace(/\n\n$/, '')
            .replace(/\s+/g, '')
        return text
    }

    $('.submit_btn').on('click', function () {
        // const contactName = xss(contactName_node.val())
        const name = xss(name_node.val())
        const phone = xss(phone_node.val())
        const area = xss(area_node.val())

        let errorStatus = false;
        const reg =
            /^(\d{11})$|^((\d{7,8})|(\d{4}|\d{3})(\d{7,8})|(\d{4}|\d{3})(\d{7,8})(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})(\d{4}|\d{3}|\d{2}|\d{1}))$/;
        if (!phone) {
            setErrorStyle(phone_node, '联系人电话必填');
            errorStatus = true;
        } else if (!reg.test(phone)) {
            setErrorStyle(phone_node, '请输入正确的电话号码');
            errorStatus = true;
        } else {
            setSuccessStyle(phone_node);
        }
        if (errorStatus) {
            return;
        }
        $('.submit_btn').attr('disabled', true)
        const callback = (request) => {
            $.ajax({
                url: 'https://gateway.system.realmerit.com.cn/release/offical/api/website/concat',
                method: 'post',
                contentType: 'application/json;charset=UTF-8',
                data: JSON.stringify({
                    randStr: request.randStr,
                    Ticket: request.Ticket,
                    orgName: name || '没有提供机构名称',
                    area: area || '',
                    phone,
                    contactName: '',
                    message: '',
                    type: 'home'
                }),
                success: function ({code}) {
                    $('.submit_btn').attr('disabled', false)
                    if (code === 0) {
                        applyModal.fadeOut()
                        resetFormVal()
                        alert('提交成功')
                        return
                    }
                    alert('提交失败')
                },
                error: function () {
                    $('.submit_btn').attr('disabled', false)
                    alert('提交失败')
                },
            })
        }
        swipeToVerify(callback)
    })
}
